import '@beyondtrust/btux-iconography-web';
import { LitElement, html } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { choose } from 'lit/directives/choose.js';
import {
  ADMIN_SLUG,
  AI_COWORKERS_SLUG,
  ENTITLE_SLUG,
  EPML_SLUG,
  INSIGHTS_SLUG,
  PASSWORD_SAFE_SLUG,
  PLATFORM_SLUG,
  PMC_SLUG,
  PRIVILEGED_REMOTE_ACCESS_SLUG,
  ProductSlug,
  REMOTE_SUPPORT_SLUG,
  SECRETS_SLUG,
} from '../../types';

export const PLATFORM_PRODUCT_ICON_TAG = 'platform-product-icon' as const;

/**
 * Component used to render the appropriate
 * product icon based on product slug.
 */
@customElement(PLATFORM_PRODUCT_ICON_TAG)
export class PlatformProductIcon extends LitElement {
  @property()
  productSlug!: ProductSlug;

  override render() {
    return html`
      ${choose(
        this.productSlug,
        [
          [ADMIN_SLUG, () => html`<btux-svg name="gears"></btux-svg>`],
          [AI_COWORKERS_SLUG, () => html`<btux-svg name="ai-agent-security"></btux-svg>`],
          [ENTITLE_SLUG, () => html`<btux-svg name="bt-entitle"></btux-svg>`],
          [EPML_SLUG, () => html`<btux-svg name="bt-privilege-management-linux-unix"></btux-svg>`],
          [INSIGHTS_SLUG, () => html`<btux-svg name="bt-insights"></btux-svg>`],
          [PASSWORD_SAFE_SLUG, () => html`<btux-svg name="bt-password-safe"></btux-svg>`],
          [PLATFORM_SLUG, () => html`<btux-svg name="bt-logo"></btux-svg>`],
          [PMC_SLUG, () => html`<btux-svg name="bt-privilege-management-win-mac"></btux-svg>`],
          [PRIVILEGED_REMOTE_ACCESS_SLUG, () => html`<btux-svg name="bt-privileged-remote-access"></btux-svg>`],
          [REMOTE_SUPPORT_SLUG, () => html`<btux-svg name="bt-remote-support"></btux-svg>`],
          [SECRETS_SLUG, () => html`<btux-svg name="bt-workload-credentials"></btux-svg>`],
        ],
        () => html``,
      )}
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    [PLATFORM_PRODUCT_ICON_TAG]: PlatformProductIcon;
  }
}
